import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Typography } from '@mui/material';

const CodeBlock = ({ className, children }) => {
  const [copied, setCopied] = useState(false);
  const language = className ? className.replace('language-', '') : 'text';
  const codeString = String(children).trim();

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    console.log('className changed', {className});
  }, [className]);

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ padding: '2px', borderBottom: '0px solid #ddd' }}>
        <Typography>{className ? className.replace('language-', '') : 'text'}</Typography>
        <CopyToClipboard text={codeString} onCopy={handleCopy}>
          <span style={{ position: 'absolute', right: 0, top: 0, cursor: 'pointer' }} title="Copy">
            <ContentCopyIcon fontSize="small" />
            {copied ? 'Copied!' : 'Copy code'}
          </span>
        </CopyToClipboard>
      </div>
      <SyntaxHighlighter
        language={language}
        style={oneDark}
        showLineNumbers
        PreTag="div"
        className="codeStyle"
        useInlineStyles={true}
      >
        {String(children).replace(/\n$/, '')}
      </SyntaxHighlighter>
    </div>
  );
};

const Message = ({ text }) => {
  return (
    <div className="message">
      <ReactMarkdown
        children={text}
        components={{
          code({ node, inline, className, children, ...props }) {
            return !inline ? (
              <CodeBlock className={className} {...props}>
                {children}
              </CodeBlock>
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
        }}
      >
       
      </ReactMarkdown>
    </div>
  );
};

export default Message;
